export const ADD = 'NOTIFICATIONS_ACTIONS_ADD';
export const REMOVE = 'NOTIFICATIONS_ACTIONS_REMOVE';
